<div class="hub-home-container hub-custom-scrollbar">

  <img class="goals-header" src="assets/images/home/2030Goals.png">

  <div class="home-blurb">
    <p>
      The Nature Conservancy is committed to our 2030 goals to address biodiversity loss and climate change.
      Learn more about our targets below, and our progress toward them.
    </p>
    <p>
      Click on a goal to view additional metric details. Learn more about TNC's Role <a
    href="https://tnc.box.com/s/g30iw1vx9vz8m8xw02gn0rx29uze593y" target="_blank">here</a>.
  </p>
</div>

@if (goals) {
  <div class="goals-panel">
    @for (goal of goals; track goal) {
      <app-goal-display [goal]="goal" (gotoGoalDetailsRequested)="gotoGoalDetails($event)">
      </app-goal-display>
    }
  </div>
}

</div>
